import {Action, Module, MutationAction, VuexModule} from "vuex-module-decorators";
import {
    OrganisationMemberEntry,
    OrganisationRef,
    organisationService,
    TimeAssignment
} from "@/modules/organisations/services/OrganisationService";
import {MemberRef} from "@/modules/members/services/MemberService";

@Module({namespaced: true, name: 'organisation-members'})
export default class OrganisationMembersModule extends VuexModule {
    members: Array<OrganisationMemberEntry> = []
    timeAssignment: TimeAssignment = {max: 0, used: 0} as TimeAssignment

    @MutationAction
    async loadMembers(req: LoadOrganisationMembersRequest) {
        const overview = await organisationService.getOrganisationMembersOverview(req.ref, req.showInActive)
        return {members: overview.members, timeAssignment: overview.timeAssignment}
    }

    @Action
    async endMembership(req: EndMembershipRequest) {
        await organisationService.endOrganisationMemberMembership(req.organisationRef, req.data, req.end)
    }
}

export interface LoadOrganisationMembersRequest {
    ref: OrganisationRef,
    showInActive: boolean
}

export interface EndMembershipRequest {
    organisationRef: OrganisationRef,
    data: MemberRef,
    end: Date | undefined
}